import { ThemeProvider } from "@emotion/react";
import { PropTypes } from "prop-types";
import {
  IconButton,
  InputAdornment,
  TextField,
  createTheme,
} from "@mui/material";
import React from "react";
import { padding } from "@mui/system";

// 'filled'
//  'outlined'
//  'standard'

const CommonInput = ({
  readOnly = false,
  icon,
  password = false,
  showPassword = false,
  verify = null,
  required = false,
  passwordIconOff,
  passwordIcon,
  value,
  placeholder,
  filled,
  label,
  name,
  backgroundColor = "grey",
  removeBackGround = false,
  labelStyle = {},
  focusedStyles = {},
  onClick = () => {},
  onChange = () => {},
  onBlur = () => {},
  onMouseDown = () => {},
  onKeyDown = () => {},
  isTextArea = false,
  sx = {},
  size,
  leftAlign = false,
  padding,
  opacity,
  outlineStyle = null,
  maxLength,
}) => {
  const FilledInputProp = {
    readOnly: readOnly ? true : false,
    startAdornment: leftAlign && (
      <InputAdornment position="start">{icon}</InputAdornment>
    ),
    endAdornment: password ? (
      <InputAdornment
        position="end"
        onClick={onClick}
        onMouseDown={onMouseDown}
        sx={{ cursor: "pointer" }}
      >
        {showPassword ? passwordIconOff : passwordIcon}
      </InputAdornment>
    ) : verify ? (
      <InputAdornment position="end">{verify}</InputAdornment>
    ) : (
      !leftAlign && <InputAdornment position="end">{icon}</InputAdornment>
    ),
  };

  const FilledStyle = {
    borderRadius: "10px",
    background: "#E42125",
    width: "100%",
    height: "auto",
    input: {
      "&::placeholder": {
        textOverflow: "ellipsis !important",
        color: "white",
        opacity: 1,
        fontSize: "1.6rem",
      },
      padding: padding,
      fontSize: "1.6rem",
      color: "white",
    },
    "& fieldset": { border: "none" },
    ...sx,
  };

  const outlinedStyle = {
    background: removeBackGround ? "none" : backgroundColor,
    borderRadius: "5px",
    width: "100%",
    height: outlineStyle ? outlineStyle?.height : "auto",
    "& fieldset": { border: "none" },
    border: "1px solid #E8E8E8",
    "& .Mui-focused": { ...focusedStyles },
    "& .MuiOutlinedInput-root": {
      width: "inherit",
      height: outlineStyle ? outlineStyle?.height : "auto",
      paddingRight: outlineStyle ? outlineStyle?.paddingRight : "14px",
      " &.Mui-focused fieldset": {
        borderColor: "#E8E8E8",
      },
    },
    "&:hover fieldset": {
      borderColor: "#E8E8E8",
      border: "none",
    },
    input: {
      "&::placeholder": {
        textOverflow: "ellipsis !important",
        color: "grey",
        opacity: 1,
        fontSize: "1.6rem",
      },
      padding: padding,
      opacity: opacity,
      fontSize: "1.6rem",
      color: removeBackGround ? "black" : backgroundColor,
    },
    ...sx,
  };

  const textArea = {
    "& .MuiInputBase-root": {
      padding: "0rem",
      fontSize: "1rem",
      height: "auto",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        border: "none",
      },
      "&:hover fieldset": {
        border: "none",
      },
      "&.Mui-focused fieldset": {
        border: "none",
      },
    },
  };

  return (
    <>
      {label && (
        <p
          style={{
            marginBottom: "1rem",
            color: "#3a3a3a",
            fontSize: "1.25rem",
            fontWeight: 500,
            ...labelStyle,
          }}
        >
          {label + " "}
          {required ? <span style={{ color: "red" }}>*</span> : ""}
        </p>
      )}
      <TextField
        multiline={isTextArea}
        autoComplete="off"
        autoFocus={isTextArea}
        InputProps={FilledInputProp}
        inputProps={{ maxLength: maxLength }}
        value={value}
        name={name}
        onChange={onChange}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
        type={showPassword ? "password" : "text"}
        placeholder={placeholder}
        size={size}
        sx={filled ? FilledStyle : isTextArea ? textArea : outlinedStyle}
      />
    </>
  );
};

CommonInput.propTypes = {
  readOnly: PropTypes.bool,
  icon: PropTypes.element,
  password: PropTypes.bool,
  showPassword: PropTypes.bool,
  passwordIconOff: PropTypes.element,
  passwordIcon: PropTypes.element,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  filled: PropTypes.bool,
  onClick: PropTypes.func,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyDown: PropTypes.func,
  onMouseDown: PropTypes.func,
  removeBackGround: PropTypes.bool,
  label: PropTypes.string,
  leftAlign: PropTypes.bool,
  padding: PropTypes.string,
  opacity: PropTypes.number,
  maxLength: PropTypes.number,
};

export default CommonInput;
